var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-notification"},[_c('p',{staticClass:"d-title text-center mb-2",staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"d-desc text-center mb-0",staticStyle:{"font-family":"Gilroy-Medium"}},[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }